var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "quill-editor" },
    [
      _vm._t("toolbar"),
      _vm._v(" "),
      _c("div", { ref: "editor", style: { minHeight: _vm.minHeight } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }